import { EntityModel } from '@/interfaces'
import {
  ALL_DATE_SWITCH_SETTINGS_QUERY,
  CREATE_DATE_SWITCH_SETTINGS_MUTATION,
  DELETE_DATE_SWITCH_SETTINGS_MUTATION,
  FORCE_DELETE_DATE_SWITCH_SETTINGS_MUTATION,
  SINGLE_DATE_SWITCH_SETTINGS_QUERY,
  UPDATE_DATE_SWITCH_SETTINGS_MUTATION,
} from './graphql'

const travelServiceDateSwitchSettingsModel: EntityModel = {
  name: 'dateSwitchSettings',
  namePlural: 'dateSwitchSettings',
  uniqueName: 'travelServiceDateSwitchSettings',
  uniqueNamePlural: 'travelServiceDateSwitchSettings',
  path: 'travel/pricing/services/date_switch_settings',
  baseUrl: '/travel/pricing/services/date_switch_settings',
  translationPrefix: 'entities:travelServiceDateSwitchSettings.',
  getDisplayName: (values: any) => {
    return 'TRAVEL SERVICE DATE SWITCH SETTINGS'
  },
  gql: {
    getAll: ALL_DATE_SWITCH_SETTINGS_QUERY,
    getSingle: SINGLE_DATE_SWITCH_SETTINGS_QUERY,
    create: CREATE_DATE_SWITCH_SETTINGS_MUTATION,
    update: UPDATE_DATE_SWITCH_SETTINGS_MUTATION,
    delete: DELETE_DATE_SWITCH_SETTINGS_MUTATION,
    forceDelete: FORCE_DELETE_DATE_SWITCH_SETTINGS_MUTATION,
  },
  attributes: {
    startDateOffsetDays: {
      name: 'startDateOffsetDays',
      label: 'entities:travelServiceDateSwitchSettings.attributes.startDateOffsetDays.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'number',
      validationType: 'string',
      validations: [],
    },
    endDateOffsetDays: {
      name: 'endDateOffsetDays',
      label: 'entities:travelServiceDateSwitchSettings.attributes.endDateOffsetDays.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'number',
      validationType: 'string',
      validations: [],
    },
  },
}

export default travelServiceDateSwitchSettingsModel
